import {Box, Button, Divider, Flex, FormControl, FormLabel, HStack, IconButton, Input, Stack, Text, useColorModeValue} from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';
import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { ToastContainer } from 'react-toastify';
import { addCustomer } from '../../store/actions';
import { addCustomerFormValidation } from '../../utils';
import { customerFormTypes } from '../../types';
import { useFormik } from 'formik';

export const AddCustomer = () => {

    const [origin, setOrigin] = useState<any | null>(null);
    const [coords, setCoords] = useState<any | null>(null);

    const { is_adding_customer } = useAppSelector(state => state.customersReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const customerForm = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            phone: '',
            email: '',
            address: origin?.label,
            coords: {
                lat: coords?.lat,
                long: coords?.long,
            }
        },
        validationSchema: addCustomerFormValidation,
        onSubmit: (values: customerFormTypes) => {
            const address = origin?.label;
            const newValues: any = { ...values, address, coords, lat: coords?.lat, long: coords?.long };
            dispatch(addCustomer(newValues)).then(() => navigate('/customers'));
            // alert(JSON.stringify(newValues, null, 2));
        }
    });

    const getCoords = useCallback(() => {
        origin && geocodeByAddress(origin?.label)
            .then((results: Array<any>) => getLatLng(results[0]))
            .then(({ lat, lng }: any) => {
                setCoords({ lat: lat, long: lng });
            }
            );
    }, []);

    useEffect(() => {
        getCoords();
    }, [is_adding_customer]);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                    <HStack align={'center'}>
                            <Stack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/customers' />
                            </Stack>
                            <Stack>
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Add new customer.
                                </Text>
                            </Stack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <form onSubmit={customerForm.handleSubmit}>
                            <HStack>
                                <Box>
                                    <FormControl id="first_name" isRequired mb={customerForm.errors.first_name ? 0 : 5}>
                                        <FormLabel>First name</FormLabel>
                                        <Input name='first_name' type="text" value={customerForm.values.first_name} onChange={customerForm.handleChange} />
                                        {customerForm.errors.first_name && <Text fontSize='sm' color='red.400'>{customerForm.errors.first_name}</Text>}
                                    </FormControl>
                                </Box>
                                <Box>
                                    <FormControl id="last_name" isRequired mb={customerForm.errors.last_name ? 0 : 5}>
                                        <FormLabel>Last name</FormLabel>
                                        <Input name='last_name' type="text" value={customerForm.values.last_name} onChange={customerForm.handleChange} />
                                        {customerForm.errors.last_name && <Text fontSize='sm' color='red.400'>{customerForm.errors.last_name}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack>
                                <Box>
                                    <FormControl id="phone" isRequired mb={customerForm.errors.phone ? 0 : 5}>
                                        <FormLabel>Phone number</FormLabel>
                                        <Input name='phone' type="text" value={customerForm.values.phone} onChange={customerForm.handleChange} />
                                        {customerForm.errors.phone && <Text fontSize='sm' color='red.400'>{customerForm.errors.phone}</Text>}
                                    </FormControl>
                                </Box>
                                <Box>
                                    <FormControl id="email" isRequired mb={customerForm.errors.email ? 0 : 5}>
                                        <FormLabel>Email</FormLabel>
                                        <Input name='email' type="email" value={customerForm.values.email} onChange={customerForm.handleChange} />
                                        {customerForm.errors.email && <Text fontSize='sm' color='red.400'>{customerForm.errors.email}</Text>}
                                    </FormControl>
                                </Box>
                            </HStack>
                            <FormControl id="address" isRequired mb={origin ? 3 : 5}>
                                <FormLabel>Address</FormLabel>
                                <GooglePlacesAutocomplete
                                    apiKey='AIzaSyCsvDO2ZMssvwhcmIo2TqXvJSL0zlMD5bw'
                                    apiOptions={{ region: 'za' }}
                                    selectProps={{
                                        placeholder: 'Address',
                                        origin,
                                        onChange: setOrigin
                                    }}
                                />
                                {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                {!origin && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                            </FormControl>
                            <Stack spacing={10} pt={2}>
                                <Button
                                    type='submit'
                                    isLoading={is_adding_customer}
                                    disabled={is_adding_customer}
                                    loadingText="Submitting"
                                    size="lg"
                                    colorScheme={'yellow'}
                                    >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};